import React from "react"
import {Route, Routes} from "react-router-dom";
import {CreateSiteAlertPage} from "@/pages/alerts/create-site-alert";
import {EditSiteAlert} from "@/pages/alerts/edit-site-alert";
import {SiteAlertsListPage} from "@/pages/alerts/site-alerts-list";
import {ImportSiteAlerts} from "@/pages/alerts/import-site-alerts";
import {BodyWrapper} from "@/components/body-wrapper";


export function SiteAlertRoutes() {
    return (
        <BodyWrapper>
            <Routes>
                <Route
                    path="/"
                    element={
                        <SiteAlertsListPage/>
                    }
                />

                <Route
                    path="/import"
                    element={
                        <ImportSiteAlerts/>
                    }
                />

                <Route
                    path="/create"
                    element={
                        <CreateSiteAlertPage/>
                    }
                />

                <Route
                    path="/edit/:id"
                    element={
                        <EditSiteAlert/>
                    }
                />
            </Routes>
        </BodyWrapper>
    )
}
